import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo, { getSiteUrl } from '../components/Seo';
import CollectionLinks from '../components/CollectionLinks';
import { useI18n } from '../i18n/I18nContext';
import { getLocalizedPath } from '../i18n/localizedRoutes';
import getApiBase from '../utils/apiBase';
import { getProductPath } from '../utils/productSlug';
import { resolveImageUrl } from '../utils/resolveImageUrl';
import { getCatalogCopy } from './catalogCopy';
import { belongsToCollection, COLLECTION_SLUGS } from './collections';
import NotFoundPage from './NotFoundPage';
import './CollectionPage.css';

const CollectionPage = ({ initialCatalog = [] }) => {
  const { collectionSlug } = useParams();
  const { t, locale, formatNumber } = useI18n();
  const [catalog, setCatalog] = useState(initialCatalog);
  useEffect(() => {
    let active = true;
    fetch(`${getApiBase()}/api/products`).then((response) => response.ok ? response.json() : null)
      .then((products) => { if (active && Array.isArray(products)) setCatalog(products); }).catch(() => {});
    return () => { active = false; };
  }, []);
  if (!COLLECTION_SLUGS.includes(collectionSlug)) return <NotFoundPage />;
  const products = catalog.filter((product) => belongsToCollection(product, collectionSlug));
  const path = `/collections/${collectionSlug}`;
  const url = `${getSiteUrl()}${getLocalizedPath(path, locale)}`;
  const title = t(`collections.${collectionSlug}.title`);
  const description = t(`collections.${collectionSlug}.description`);
  const productPath = (product) => getLocalizedPath(product.path || getProductPath(product, catalog), locale);
  const schema = {
    '@context': 'https://schema.org', '@type': 'CollectionPage', url, name: title, description, inLanguage: locale,
    mainEntity: { '@type': 'ItemList', itemListElement: products.map((product, index) => ({
      '@type': 'ListItem', position: index + 1, name: product.name, url: `${getSiteUrl()}${productPath(product)}`,
    })) },
  };
  return <main className="collection-page">
    <Seo title={title} description={description} path={path} structuredData={schema} />
    <nav className="breadcrumb-nav" aria-label={t('product.breadcrumb')}>
      <Link to={getLocalizedPath('/', locale)}>{t('nav.home')}</Link> / <Link to={getLocalizedPath('/store', locale)}>{t('nav.store')}</Link> / <span>{title}</span>
    </nav>
    <header><h1>{title}</h1><p>{t(`collections.${collectionSlug}.intro`)}</p></header>
    <CollectionLinks />
    <section className="collection-advice"><h2>{t('collections.choose')}</h2><p>{t(`collections.${collectionSlug}.advice`)}</p></section>
    <section><h2>{t('collections.products')}</h2>
      <div className="collection-products">{products.map((product) => <article key={product.id}>
        <Link to={productPath(product)}><img src={resolveImageUrl(product.imageUrl)} alt={product.name} loading="lazy" width="400" height="400" /><h3>{getCatalogCopy(product, t).title}</h3></Link>
        <p>{getCatalogCopy(product, t).description}</p>
        <p>{t('common.price', { price: formatNumber(Number(product.price), { style: 'currency', currency: 'USD' }) })}</p>
        <Link to={productPath(product)}>{t('collections.view', { name: product.name })}</Link>
      </article>)}</div>
      {!products.length && <p>{t('collections.empty')}</p>}
    </section>
    <Link to={getLocalizedPath('/store', locale)}>{t('collections.all')}</Link>
  </main>;
};
export default CollectionPage;
